// @ts-nocheck
import { useEffect, useState } from 'react';
import {
  Container,
  Stack,
  Typography,
  Button,
  Card,
  CardMedia,
  CardContent,
  Grid,
  MenuItem,
  Select,
  FormLabel,
  FormControlLabel,
  Radio,
  RadioGroup,
  Modal,
  TextField,
  Box
} from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../redux/app/hooks';
import { useNavigate, useLocation } from 'react-router-dom';
import moment from 'moment';
import {
  capitalName,
  formatDateTime,
  onlyLastEmailShow,
  onlyLastFourNum,
} from '../../../redux/services/utility';
import Iconify from "../../../components/Iconify";
import Loading from '../../commons/Loading';
import { getUserData } from '../../../redux/slices/authSlice';
import {
  useSaveCustomerFeedbackMutation, useGetAllCustomerFeedbackMutation,
  useFindCustomerFeedbackByBookingIdMutation
} from '../../../redux/services/feedbackApi';
import { Formik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import ArrowImage from "../../../assets/ArrowImage.png"
import Cancel from "../../../assets/Cancel.png"
import VehicleDetails from "../../../assets/VehicleDetails.png"
import PaymentDetail from "../../../assets/PaymentDetail.png"
import MyBooking from "../../../assets/MyBooking.png"
import ContactDetail from "../../../assets/Profile@2x.png"
import Passengers from "../../../assets/Passengers@4x.png"
import Feedback from "../../../assets/Feedback.png"
import clearIcon from "../../../assets/Cancel.png"



export default function ViewBooking() {
  const userData = useSelector(getUserData);
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const token: string = currentUser?.jwtToken;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { state } = useLocation();
  console.log("State:", state);
  const role = useAppSelector(getUserData);
  const location = useLocation();
  const [saveCustomerFeedback, saveCustomerFeedbackResponse] = useSaveCustomerFeedbackMutation();
  const [findCustomerFeedbackByBookingId, findCustomerFeedbackByBookingIdResponse] = useFindCustomerFeedbackByBookingIdMutation();
  const bookingDetails = location.state?.bookingDetails;
  console.log(bookingDetails?.isPartialPaid ,"bookingDetails?.isPartialPaid");
  console.log(bookingDetails, "bookingDetails");
  const booking: string = location.state?.booking || "";
  const [feedback, setFeedback] = useState(null);
  const [formValues, setFormValues] = useState({
    driverRating: 0,
    customerServiceRating: 0,
    comments: ""
  });

  useEffect(() => {
    findCustomerFeedbackByBookingId({
      token: token,
      bookingId: bookingDetails.id,
    });
  }, []);

  useEffect(() => {
    if (findCustomerFeedbackByBookingIdResponse.isSuccess) {
      console.log("Feedback:", findCustomerFeedbackByBookingIdResponse.data);
      setFeedback(findCustomerFeedbackByBookingIdResponse.data);
    }
  }, [findCustomerFeedbackByBookingIdResponse.isSuccess]);

  const [isOpenCancellationPolicy, setIsOpenCancellationPolicy] = useState(false)
  const [isOpenPaymentDetail, setIsOpenPaymentDetail] = useState(false)
  const [isOpenPassengerDetails, setIsOpenPassengerDetails] = useState(false);
  const [isOpenFeedbackDetails, setIsOpenFeedbackDetails] = useState(false);
  const [isOpenContactDetail, setIsOpenContactDetail] = useState(false);

  const processCancellationPolicy = (policy) => {
    if (!policy) return "N/A";

    const updatedPolicy = policy.replace(/<h4>General Rules:<\/h4>/, "");
    return updatedPolicy;
  };

  const styleActiveModel = {
    position: "absolute" as "absolute",
    top: "52%",
    left: "47%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "10px",
    p: "40px",
    px: "40px",
  };

  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState(false) as any;

  const handleClose = () => {
    setOpen(false);
  };

  const handleFeedback = (values) => {
    saveCustomerFeedback({
      token: token,
      payload: {
        bookingId: bookingDetails?.id,
        comments: values?.comments,
        customerId: bookingDetails?.customerDetailResponseDTO?.id,
        date: new Date().toISOString(),
        driverRating: values?.driverRating,
        rating: values?.customerServiceRating,
        merchantId: bookingDetails?.customerDetailResponseDTO?.merchantId,
        serviceProviderId: bookingDetails?.serviceProviderId
      },
    });
    handleClose();
  };

  useEffect(() => {
    console.log("Booking Details:", bookingDetails);
    console.log("Customer Id:", bookingDetails?.customerDetailResponseDTO?.customerId);
    //console.log("feedback:",feedback);
  }, []);

  const isDisabled = !['Completed', 'Cancelled', 'Cancellation in review'].includes(bookingDetails?.bookingStatus);


  return (
    <div className='mb-5 m-2'>
      <div>
        {/* Booking Detail */}
        <div className="bg-[#F9F4EF] rounded-3xl p-4 w-full shadow-md">
          {/* Title with Icon */}
          <div className="flex items-center mb-2">
            <img src={MyBooking} alt="Booking Icon" className="w-4 h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 mr-2" />
            <h2 className="text-sm md:text-base lg:text-lg font-bold text-[#58595B]">Booking Details</h2>
          </div>
          {/* Booking Details List */}
          <div className="space-y-2">
            <div className="flex justify-between">
              <p className="font-semibold text-[#58595B] text-xs md:text-sm lg:text-base">Pickup Address</p>
              <p className="text-[#58595B] text-right text-xs md:text-sm lg:text-base">{bookingDetails?.fromLocation}</p>
            </div>
            {(bookingDetails?.toLocation) &&
              <div className="flex justify-between">
                <p className="font-semibold text-[#58595B] text-xs md:text-sm lg:text-base">Dropoff Address</p>
                <p className="text-[#58595B] text-right text-xs md:text-sm lg:text-base">{bookingDetails?.toLocation}</p>
              </div>
            }
            <div className="flex justify-between">
              <p className="font-semibold text-[#58595B] text-xs md:text-sm lg:text-base">Pickup Date & Time</p>
              <p className="text-[#58595B] text-right text-xs md:text-sm lg:text-base">{formatDateTime(bookingDetails?.checkinTime, "MM/DD/YYYY hh:mm A")}</p>
            </div>
            {(bookingDetails?.checkoutTime) &&
              <div className="flex justify-between">
                <p className="font-semibold text-[#58595B] text-xs md:text-sm lg:text-base">Dropoff Date & Time</p>
                <p className="text-[#58595B] text-right text-xs md:text-sm lg:text-base">{formatDateTime(bookingDetails?.checkoutTime, "MM/DD/YYYY hh:mm A")}</p>
              </div>
            }
            <div className="flex justify-between">
              <p className="font-semibold text-[#58595B] text-xs md:text-sm lg:text-base">Booking Code</p>
              <p className="text-[#58595B] text-xs md:text-sm lg:text-base">{bookingDetails?.bookingCode}</p>
            </div>
            <div className="flex justify-between">
              <p className="font-semibold text-[#58595B] text-xs md:text-sm lg:text-base">Booking Status</p>
              <p className="text-[#58595B] text-xs md:text-sm lg:text-base">{capitalName(bookingDetails?.bookingStatus)}</p>
            </div>
            <div className="flex justify-between">
              <p className="font-semibold text-[#58595B] text-xs md:text-sm lg:text-base">Transaction Ref ID</p>
              <p className="text-[#58595B] text-xs md:text-sm lg:text-base">{bookingDetails?.transactionRefId}</p>
            </div>
          </div>
        </div>
        {/* Vehicle Detail */}
        <div className="bg-[#F9F4EF] rounded-3xl p-4 w-full mt-5 shadow-md">
          {/* Title with Icon */}
          <div className="flex items-center mb-4">
            <img src={VehicleDetails} alt="Car Icon" className="w-6 h-6 mr-2" />
            <h2 className="text-base md:text-lg font-bold text-[#58595B]">
              Vehicle Details
            </h2>
          </div>

          {/* Vehicle Details */}
          <div className="flex flex-col md:flex-row justify-between space-y-2 md:space-y-0">
            <p className="text-[#58595B] text-xs sm:text-sm md:text-base">
              <strong>Vehicle Type:</strong> {bookingDetails?.parkingSpaceLocationRespDTO?.vehicleDetailObj?.type || "N/A"}
            </p>
            <p className="text-[#58595B] text-xs sm:text-sm md:text-base">
              <strong>Vehicle Number:</strong> {bookingDetails?.parkingSpaceLocationRespDTO?.vehicleDetailObj?.chassisNumber || "N/A"}
            </p>
            <p className="text-[#58595B] text-xs sm:text-sm md:text-base">
              <strong>Seating Capacity:</strong> {bookingDetails?.parkingSpaceLocationRespDTO?.vehicleDetailObj?.seatingCapacity || "N/A"}
            </p>
          </div>
        </div>

        {/* Cancellation Policy */}
        <div className="bg-[#F9F4EF] rounded-3xl p-4 w-full mt-5 shadow-md">
          {/* Title with Toggle Icon */}
          <div
            className="flex items-center justify-between cursor-pointer"
            onClick={() => setIsOpenCancellationPolicy(!isOpenCancellationPolicy)}
          >
            <div className="flex items-center">
              <img src={Cancel} alt="Close Icon" className="w-4 h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 mr-2 text-red-500" />
              <h2 className="text-sm md:text-base lg:text-lg font-bold text-[#58595B]">
                Cancellation Policy
              </h2>
            </div>
            <img
              src={ArrowImage}
              alt="Dropdown Icon"
              className={`md:w-5 md:h-5 h-4 w-4 text-red-500 ${isOpenCancellationPolicy ? "rotate-180" : ""
                }`}
            />
          </div>
          {/* Cancellation Policy Details */}
          {isOpenCancellationPolicy && (
            <div className="mt-3 text-sm md:text-base text-[#58595B]">
              <p dangerouslySetInnerHTML={{
                __html: processCancellationPolicy(
                  bookingDetails?.parkingSpaceLocationRespDTO?.cancellationPolicy || "No policy available"
                ),
              }} />
            </div>
          )}
        </div>
        <div className="bg-[#F9F4EF] rounded-3xl p-4 w-full mt-5 shadow-md">
          {/* Title with Toggle Icon */}
          <div
            className="flex items-center justify-between cursor-pointer"
            onClick={() => setIsOpenPaymentDetail(!isOpenPaymentDetail)}
          >
            <div className="flex items-center">
              <img src={PaymentDetail} alt="Close Icon" className="w-5 h-5 md:w-6 md:h-6 lg:w-7 lg:h-7  mr-2" />
              <h2 className="text-sm md:text-base lg:text-lg font-bold text-[#58595B]">
                Payment Detail
              </h2>
            </div>
            <img
              src={ArrowImage}
              alt="Dropdown Icon"
              className={`md:w-5 md:h-5 h-4 w-4 ${isOpenPaymentDetail ? "rotate-180" : ""}`}
            />
          </div>
          {/* Payment Details */}
          {isOpenPaymentDetail && (
            <div className="mt-4">
              <div className="flex justify-between mb-3 border-b-2 pb-2">
                <p className="text-base font-medium text-[#58595B]">
                  Paid by {bookingDetails?.paymentMethodName}
                </p>
              </div>

              <div className="flex justify-between mb-2">
                <p className="text-base font-medium text-[#58595B]">Vehicle Charges:</p>
                <p className="text-base font-medium text-[#58595B]">
                  ₹{(bookingDetails?.totalAmount - (bookingDetails?.tollCharges || 0)).toFixed(2)}
                </p>
              </div>

              {bookingDetails?.discount > 0 && (
                <div className="flex justify-between mb-2">
                  <p className="text-base font-medium text-[#58595B]">
                    Discount: {bookingDetails?.discountType === "%" && `(${bookingDetails?.discount}%)`}
                  </p>
                  <p className="text-base font-medium text-red-500">
                    -₹{bookingDetails?.discountAmount?.toFixed(2)}
                  </p>
                </div>
              )}

              {bookingDetails?.offerDiscount > 0 && (
                <div className="flex justify-between mb-2">
                  <p className="text-base font-medium text-[#58595B]">Offer Discount:</p>
                  <p className="text-base font-medium text-red-500">
                    -₹{bookingDetails?.offerDiscount?.toFixed(2)}
                  </p>
                </div>
              )}

              {bookingDetails?.redeemAmount > 0 && (
                <div className="flex justify-between mb-2">
                  <p className="text-base font-medium text-[#58595B]">Finder Bucks:</p>
                  <p className="text-base font-medium text-green-600">
                    ₹{bookingDetails?.redeemAmount?.toFixed(2)}
                  </p>
                </div>
              )}

              {bookingDetails?.tollCharges > 0 && (
                <div className="flex justify-between mb-2">
                  <p className="text-base font-medium text-[#58595B]">Toll Charges:</p>
                  <p className="text-base font-medium text-[#58595B]">
                    ₹{bookingDetails?.tollCharges?.toFixed(2)}
                  </p>
                </div>
              )}

              <div className="flex justify-between mb-2 border-t-2 pt-2">
                <p className="text-lg font-semibold text-[#58595B]">Grand Total:</p>
                <p className="text-lg font-semibold text-blue-600">
                  ₹{bookingDetails?.totalAmount?.toFixed(2)}
                </p>
              </div>

              {/**<div className="flex justify-between mb-2 border-t-2 pt-2">
                <p className="text-base font-medium text-[#58595B]">Payment Status</p>
                <p className="text-base font-medium text-[#58595B]">
                  {bookingDetails?.paymentStatus}
                </p>
              </div> */}

              {bookingDetails?.isPartialPaid  && ( 
              <>
                <div className="flex justify-between mb-2 border-t-2 pt-2">
                  <p className="text-base font-medium text-[#58595B]">Partially Paid</p>
                  <p className="text-base font-medium text-[#58595B]">
                    {bookingDetails?.isPartialPaid?"yes":"No"}
                  </p>
                </div>

                <div className="flex justify-between mb-2">
                    <p className="text-base font-medium text-[#58595B]">Paid Amount:</p>
                    <p className="text-base font-medium text-[#58595B]">
                      ₹{bookingDetails?.bookingAmount?.toFixed(2)}
                    </p>
                </div> 

                <div className="flex justify-between mb-2">
                <p className="text-base font-medium text-[#58595B]">Pending Amount:</p>
                <p className="text-base font-medium text-[#58595B]">
                  ₹{bookingDetails?.pendingAmount?.toFixed(2)}
                </p>
                </div>
              </>
              )}
            </div>
          )}
        </div>
        {/* Customer Contact Detail */}
        <div className="bg-[#fcf8f3] rounded-3xl p-4 w-full mt-5 shadow-md">
          {/* Header with Toggle */}
          <div
            className="flex items-center justify-between cursor-pointer"
            onClick={() => setIsOpenContactDetail(!isOpenContactDetail)}
          >
            <div className="flex items-center">
              <img src={ContactDetail} alt="Close Icon" className="w-4 h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 mr-2 mr-2" />
              <h2 className="text-base md:text-lg font-bold text-[#58595B]">
                Contact Detail
              </h2>
            </div>
            <img
              src={ArrowImage}
              alt="Dropdown Icon"
              className={`md:w-5 md:h-5 h-4 w-4 ${isOpenPaymentDetail ? "rotate-180" : ""}`}
            />
          </div>

          {/* Contact Info (Expandable) */}
          {isOpenContactDetail && (
            <div className="mt-3 text-sm md:text-base text-[#58595B] space-y-3">
              <div className="flex justify-between">
                <p className="font-medium">Name:</p>
                <p>{bookingDetails?.customerDetailResponseDTO?.name || "N/A"}</p>
              </div>
              <div className="flex justify-between">
                <p className="font-medium">Mobile No:</p>
                <p>{bookingDetails?.customerDetailResponseDTO?.phoneNo || "N/A"}</p>
              </div>
              <div className="flex justify-between">
                <p className="font-medium">Email Id:</p>
                <p>{bookingDetails?.customerDetailResponseDTO?.email || "N/A"}</p>
              </div>
              <div className="flex justify-between">
                <p className="font-medium">Grand Total:</p>
                <p>₹{bookingDetails?.totalAmount?.toFixed(2) || "0.00"}</p>
              </div>
            </div>
          )}
        </div>
        {/** Passenger Details */}
        <div className="bg-[#F9F4EF] rounded-3xl p-4 w-full mt-5 shadow-md">
          {/* Title with Toggle Icon */}
          <div
            className="flex items-center justify-between cursor-pointer"
            onClick={() => setIsOpenPassengerDetails(!isOpenPassengerDetails)}
          >
            <div className="flex items-center">
              <img src={Passengers} alt="passenger Details Icon" className="w-4 h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 mr-2 mr-2" />
              <h2 className="text-sm md:text-base lg:text-lg font-bold text-[#58595B]">
                Passenger Details
              </h2>
            </div>
            <img
              src={ArrowImage}
              alt="Dropdown Icon"
              className={`md:w-5 md:h-5 h-4 w-4 text-red-500 ${isOpenPassengerDetails ? "rotate-180" : ""
                }`}
            />
          </div>
          {/* Cancellation Policy Details */}
          {isOpenPassengerDetails && (
            <div className="mt-4 bg-[#F9F4EF] rounded-lg  w-full ">
              {bookingDetails?.travelerDetail?.map((passenger, index) => {
              let parsedPassenger;
              try {
                parsedPassenger = typeof passenger === "string" ? JSON.parse(passenger) : passenger;
              } catch (error) {
                console.error("Invalid JSON in passenger detail:", passenger);
                return null;
              }

              return (
                <div key={index} className="mt-1">
                  <p className="text-sm font-semibold text-gray-700 mb-2">
                    <span className="text-gray-600">Passenger:</span>
                  </p>
                  <p className="text-sm font-semibold text-gray-700">
                    Adults: <span className="font-medium">{parsedPassenger?.adults || 0}</span>
                  </p>
                  <p className="text-sm font-semibold text-gray-700">
                    Kids: <span className="font-medium">{parsedPassenger?.kids || 0}</span>
                  </p>
                </div>
              );
            })}
            </div>
          )}
        </div>
        {feedback?.id && (
          <div className="bg-[#F9F4EF] rounded-3xl p-4 w-full mt-5 shadow-md">
            {/* Title with Toggle Icon */}
            <div className="flex items-center justify-between cursor-pointer"
              onClick={() => setIsOpenFeedbackDetails(!isOpenFeedbackDetails)}>
              <div className="flex items-center">
                <img src={Feedback} alt="Close Icon" className="w-6 h-6 md:w-7 md:h-7 lg:w-8 lg:h-8  mr-2" />
                <h2 className="text-base md:text-lg font-bold text-[#58595B]">
                  Your Feedback
                </h2>
              </div>
              <img src={ArrowImage} alt="Dropdown Icon"
                className={`md:w-5 md:h-5 h-4 w-4 text-red-500 ${isOpenFeedbackDetails ? "rotate-180" : ""}`} />
            </div>
            {isOpenFeedbackDetails && (
              <div className="mt-2">
                {/* Driver Rating */}
                <div className="mb-4 flex justify-between items-center">
                  <p className="text-sm md:text-base font-semibold text-[#58595B]">Driver Rating</p>
                  <p className="text-sm md:text-base font-medium text-[#58595B] flex gap-1">
                    {Array.from({ length: 5 }).map((_, starIndex) => (
                      <span
                        key={starIndex}
                        className={`text-lg md:text-xl ${feedback?.driverRating > starIndex ? "text-yellow-500" : "text-gray-300"}`}
                      >
                        ★
                      </span>
                    ))}
                  </p>
                </div>
                {/* Customer Service Experience */}
                <div className="mb-4 flex justify-between items-center">
                  <p className="text-sm md:text-base font-semibold text-[#58595B]">Customer Service Experience</p>
                  <p className="text-sm md:text-base font-medium text-[#58595B] flex gap-1">
                    {Array.from({ length: 5 }).map((_, starIndex) => (
                      <span
                        key={starIndex}
                        className={`text-lg md:text-xl ${feedback?.rating > starIndex ? "text-yellow-500" : "text-gray-300"}`}
                      >
                        ★
                      </span>
                    ))}
                  </p>
                </div>
                {/* Comments */}
                <div className="mb-4 flex justify-between items-start">
                  <p className="text-sm md:text-base font-semibold text-[#58595B]">Comments</p>
                  <p className="text-sm md:text-base font-medium text-[#58595B] text-right break-words max-w-[60%]">
                    {feedback?.comments || "No comments provided."}
                  </p>
                </div>
              </div>
            )}
          </div>
        )}
        <div className="flex justify-center items-center mt-5">
          <div className="flex space-x-4">
            {!feedback?.id && (
              <button disabled={isDisabled} onClick={() => setOpen(true)}
              className={`px-6 py-2 rounded-full transition ${
                isDisabled 
                  ? 'bg-gray-400 text-gray-200 cursor-not-allowed' 
                  : 'bg-[#ED1C24] text-white hover:bg-[#D4171F]'
              }`}
            >
              Give Feedback
            </button>
            )}
            <button onClick={() => {
              navigate('/profile/booking', { replace: true });
            }} className="bg-[#ED1C24] text-white px-6 py-2 rounded-full hover:bg-[#ED1C24]">
              Back
            </button>
          </div>
        </div>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={styleActiveModel}
          className="overflow-y-auto h-[60%] md:w-[50%] w-[90%] bg-white border border-white rounded-lg relative"
          style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
        >
          {/* Hide scrollbar for Webkit-based browsers (Chrome, Safari) */}
          <style>
            {`
        .MuiBox-root::-webkit-scrollbar {
          display: none;
        }
      `}
          </style>

          {/* Close Button in the Top-Right Corner */}
          <button className="absolute top-3 right-3" onClick={handleClose}>
            <img src={clearIcon} className="cursor-pointer w-5 h-5" />
          </button>

          <Formik
            enableReinitialize
            initialValues={formValues}
            onSubmit={handleFeedback}
            validationSchema={Yup.object({
              driverRating: Yup.number()
                .min(1, "Rating is required")
                .required("Rating is required"),
              customerServiceRating: Yup.number()
                .min(1, "Rating is required")
                .required("Rating is required"),
              comments: Yup.string().required("Comments are required"),
            })}
          >
            {({
              handleBlur,
              handleChange,
              handleSubmit,
              setFieldValue,
              values,
              touched,
              errors,
            }) => (
              <div className="">
                <h2 className="text-[#434343] font-bold text-[16px] lg:text-[20px]">
                  Feedback Form
                </h2>
                <div className="mt-5">
                  {/* Driver Rating */}
                  <div className="mb-5">
                    <div className='text-base text-[ #58595B] font-semibold '>Driver Rating</div>
                    <div className="flex items-center gap-2">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <span
                          key={star}
                          className={`text-[24px] cursor-pointer ${values.driverRating >= star ? "text-yellow-400" : "text-gray-300"
                            }`}
                          onClick={() => setFieldValue("driverRating", star)}
                        >
                          ★
                        </span>
                      ))}
                    </div>
                    {touched.driverRating && errors.driverRating && (
                      <div className="text-red-500 text-xs">{errors.driverRating}</div>
                    )}
                  </div>

                  {/* Customer Service Rating */}
                  <div className="mb-5">
                    <div className='text-base text-[ #58595B] font-semibold '>Customer Service Experience</div>
                    <div className="flex items-center gap-2">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <span
                          key={star}
                          className={`text-[24px] cursor-pointer ${values.customerServiceRating >= star ? "text-yellow-400" : "text-gray-300"
                            }`}
                          onClick={() => setFieldValue("customerServiceRating", star)}
                        >
                          ★
                        </span>
                      ))}
                    </div>
                    {touched.customerServiceRating && errors.customerServiceRating && (
                      <div className="text-red-500 text-xs">{errors.customerServiceRating}</div>
                    )}
                  </div>
                  {/* Comments */}
                  <div className="mb-5">
                    <div className='text-base text-[ #58595B] font-semibold '>Comments</div>
                    <TextField
                      color="error"
                      fullWidth
                      variant="outlined"
                      multiline
                      rows={4}
                      name="comments"
                      id="comments"
                      label="Comments"
                      value={values.comments}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="rounded-2xl bg-gray-200 p-2 mt-1"
                      sx={{
                        "&.MuiFormControl-root": { width: "100% !important" },
                        "& .MuiTextField-root": { width: "100% !important" },
                        "& .MuiInputBase-root": {
                          width: "100% !important",
                          backgroundColor: "#E5E7EB",
                          borderRadius: "999px",
                        },
                        "& .MuiOutlinedInput-root": {
                          width: "100% !important",
                          display: "flex",
                          alignItems: "center",
                        },
                        "& .MuiOutlinedInput-input": {
                          width: "100% !important",
                        },
                        "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                        "& .Mui-disabled": { color: "#9CA3AF", cursor: "not-allowed", opacity: 1, pointerEvents: "none" },
                        "& .Mui-disabled .MuiInputBase-input": { backgroundColor: "#E5E7EB" },
                        "& .MuiInputLabel-root.Mui-disabled": { backgroundColor: "transparent" },
                      }}
                    />
                    {touched.comments && errors.comments && (
                      <div className="text-red-500 text-xs">{errors.comments}</div>
                    )}
                  </div>
                </div>

                {/* Buttons */}
                <Box className="flex flex-col items-center gap-4 mt-5 mb-10">
                  {/* Give Feedback Button (Replaces Submit Feedback) */}
                  <button
                    onClick={handleSubmit}
                    className="bg-[#ED1C24] text-white px-6 py-2 rounded-full hover:bg-[#ED1C24]"
                  >
                    Give Feedback
                  </button>
                </Box>
              </div>
            )}
          </Formik>
        </Box>
      </Modal>
    </div >
  );
}
